/* eslint-disable react/no-array-index-key */
import GridBox from '@components/atoms/GridBox';
import Spacing from '@components/atoms/Spacing';
import { Heading2, Heading4 } from '@components/atoms/Typography';
import { generateIdByText } from '@lib/data/prismic/helpers';
import { useAmp } from 'next/amp';
import NextImage from 'next/image';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div<{ hideBox: boolean }>`
  margin: 2rem 0;
  font-weight: lighter;

  h4 {
    font-size: 1.5em;
    font-weight: bold;
    margin-bottom: 1em;
  }
`;

const FAQBlock = ({
  title,
  items,
  hideIcon = false,
}: {
  items: {
    question: React.ReactNode;
    answer: React.ReactNode;
  }[];
  title?: string;
  hideIcon?: boolean;
}) => {
  const isAmp = useAmp();

  const Title = hideIcon ? Heading2 : Heading4;

  return (
    <Container
      hideBox={hideIcon}
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      {title && <Heading2 id={generateIdByText(title)}>{title}</Heading2>}

      {items.map((item, index) => (
        <GridBox
          mt={[16]}
          key={index}
          flexWrap="nowrap"
          justifyContent="flex-start"
        >
          {!(hideIcon || isAmp) && (
            <Spacing right={3}>
              <NextImage
                width={80}
                height={80}
                layout="fixed"
                src="/static/images/question.png"
                alt="Pergunta"
              />
            </Spacing>
          )}

          <div
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question"
          >
            <Title itemProp="name">{item.question}</Title>
            <div
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer"
            >
              <div itemProp="text">{item.answer}</div>
            </div>
          </div>
        </GridBox>
      ))}
    </Container>
  );
};

export default FAQBlock;
